export enum UserIdTypes {
  FRONT = 'front',
  BACK = 'back',
}

export enum DefaultStripeDue {
  EXTERNAL_ACCOUNT = 'external_account',
}
